import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_3juit7iu0l: FaireBrandEntity = {
  token: "b_3juit7iu0l",
  type: "brand",
  name: "Go Get Em Tiger",
  avatarUrl:
    "https://cdn.faire.com/fastly/b1491c94326402a4bda69a22f4317c24b6f26c89133216b976b971b338839d0b.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/d1942c3bb5ffc45435ddc5ba68f7d462b917d0737368312afa0f764c214c680f.png",
  logoUrl:
    "https://cdn.faire.com/fastly/b1491c94326402a4bda69a22f4317c24b6f26c89133216b976b971b338839d0b.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/d1942c3bb5ffc45435ddc5ba68f7d462b917d0737368312afa0f764c214c680f.png",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 1,
  isInsider: true,
  description:
    "Since 2013, Go Get Em Tiger has connected people with the truly great coffees of the world. With the belief that quality is result of expertise and intention, we obsess over every detail from each coffee’s inception. We travel the world to work with award-winning farmers who share our passion, and then roast to exacting standards to best preserve each coffee’s intrinsic character. Go Get Em Tiger is your portal to the exceptional.",
  meta: {
    source: "api",
    importedAt: "2026-08-12T22:03:41.065Z",
    importedBy: "entity-db-cli",
  },
};
